import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  userGroups: [],
  allUserGroups: [],
  totalPages: 0,
  totalRecords: 0,
  userGroup: null,
  errorStatus: null,
  userGroupPermisions: [],
  userGroupRoles: [],
  userGroupUsersInGroup: [],
};
const getters = {
  getApiLoad_106: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_UserGroups(state, userGroups) {
    state.userGroups = userGroups.items;
    state.totalPages = userGroups.totalPages;
    state.totalRecords = userGroups?.totalRecords ?? 0;
  },
  SET_AllUserGroups(state, userGroups) {
    state.allUserGroups = userGroups;
  },
  SET_UserGroup(state, userGroup) {
    state.userGroup = userGroup;
  },
  SET_Permission(state, data) {
    state.userGroupPermisions = data;
  },
  SET_Role(state, data) {
    state.userGroupRoles = data;
  },
  SET_UserGroupUsersNotInGroup(state, data) {
    state.userGroupUsersNotInGroup = data.items;
    state.totalPages = data.totalPages;
    state.totalRecords = data?.totalRecords ?? 0;
  },
  SET_UserGroupUsersInGroup(state, data) {
    state.userGroupUsersInGroup = data;
  },
};
const actions = {
  errorUserGroup({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllUserGroups({ commit, dispatch, rootState }) {
    return apiClient
      .get('/UserGroups/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllUserGroups', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserGroup', error);
      });
  },
  getUserGroupsWithPagination({ commit, dispatch, rootState }, { pageNumber, pageSize, title }) {
    var url = '/UserGroups/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (title) {
      url += '&Title=' + title;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_UserGroups', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserGroup', error);
      });
  },
  addUserGroup({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/UserGroups', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserGroup', error);
      });
  },
  getUserGroup({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/UserGroups/ById?userGroupId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_UserGroup', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserGroup', error);
      });
  },
  editUserGroup({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/UserGroups/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserGroup', error);
      });
  },
  deleteUserGroup({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/UserGroups/Remove?userGroupId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserGroup', error);
      });
  },
  userGroupPrmissions({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/UserGroups/Permissions?userGroupId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_Permission', response.data);
      })
      .catch((error) => {
        dispatch('errorUserGroup', error);
      });
  },
  editUserGroupPermission({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/UserGroups/Permissions', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserGroup', error);
      });
  },
  userGroupRoles({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/UserGroups/Roles?userGroupId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_Role', response.data);
      })
      .catch((error) => {
        dispatch('errorUserGroup', error);
      });
  },
  editUserGroupRole({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/UserGroups/Role', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserGroup', error);
      });
  },
  //manage users
  getUserGroupUsersNotInGroup({ commit, dispatch, rootState }, { groupId, pageNumber, pageSize }) {
    let url =
      '/UserGroups/UsersNotInGroup?Id=' +
      groupId +
      '&PageNumber=' +
      pageNumber +
      '&PageSize=' +
      pageSize;
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_UserGroupUsersNotInGroup', response.data);
      })
      .catch((error) => {
        dispatch('errorUserGroup', error);
      });
  },
  getUserGroupUsersInGroup({ commit, dispatch, rootState }, groupId) {
    let url = '/UserGroups/Users?userGroupId=' + groupId;
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_UserGroupUsersInGroup', response.data);
      })
      .catch((error) => {
        dispatch('errorUserGroup', error);
      });
  },
  setUsersOfGroup({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/UserGroups/Users', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserGroup', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
